<div class="container p-3">
    <h1>{{ resources?.['mc.adyenOnboarding.headline'] }}</h1>

    <ng-template #subTextComponentPlaceholder phxDynamicComponent></ng-template>

    @if (!loading && hasError) {
        <div class="text-center pt-3">
            <ngb-alert type="danger" [dismissible]="false">Fehler beim Laden der Daten.</ngb-alert>
        </div>
    }

    @if (loading) {
        <div class="text-center general-spinner my-4">
            <div class="spinner-border text-danger" role="status"></div>
        </div>
    }

    <ng-container *phxVar="adyenOnboardingData$ | async as response">
        @if (response?.adyenStatus !== adyenOnboardingStatus.UNREADY) {
            @if (response?.adyenStatus === adyenOnboardingStatus.READY_FOR_CREATION) {
                <button
                    class="btn btn-lg fw-bold mmp-btn bg-primary"
                    (click)="requestAdyenAccountCreation()"
                    [disabled]="disableButton"
                >
                    @if (isButtonClickLoading) {
                        <div class="spinner-border text-light" role="status"></div>
                    }
                    {{ resources?.['mc.adyenOnboarding.readyForCreation.button'] }}
                </button>
            }
            @if (response?.adyenStatus === adyenOnboardingStatus.READY_FOR_HOP) {
                <button
                    class="btn btn-lg fw-bold mmp-btn bg-primary"
                    (click)="navigateToAdyenOnboardingPage()"
                    [disabled]="disableButton"
                >
                    @if (isButtonClickLoading) {
                        <div class="spinner-border text-light" role="status"></div>
                    }
                    {{ resources?.['mc.adyenOnboarding.goToHostedOnboardingPage.button'] }}
                </button>
            }
        } @else {
            <div class="text-center pt-3">
                <ngb-alert type="primary" [dismissible]="false">{{
                    resources?.['mc.adyenOnboarding.info.message']
                }}</ngb-alert>
            </div>
        }

        <table
            class="table table-bordered"
            [class.invisible]="loading || response?.adyenStatus !== adyenOnboardingStatus.READY_FOR_HOP"
        >
            <tbody>
                <tr>
                    <th scope="row">{{ resources?.['mc.adyenOnboarding.table.adyenAccountId'] }}</th>
                    <td>
                        {{ response?.accountHolderData?.id }}
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ resources?.['mc.adyenOnboarding.table.balanceAccountId'] }}</th>
                    <td>
                        {{ response?.accountHolderData?.primaryBalanceAccount }}
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ resources?.['mc.adyenOnboarding.table.accountStatus'] }}</th>
                    <td>
                        <phx-expansion-panel>
                            <div
                                class="status fw-bold header-content"
                                [class]="adyenOnboardingStatusToCssClassMap.get(response?.accountHolderData?.status)"
                            >
                                {{ getAccountStatusDisplayString(response) }}
                            </div>
                            <div class="body-content card bg-light my-2">
                                <div class="card-body">
                                    {{ getAccountStatusInfoMessage(response) }}
                                </div>
                            </div>
                        </phx-expansion-panel>
                    </td>
                </tr>

                @if (compareFromBalanceCapabilities(response); as status) {
                    <tr>
                        <th scope="row">{{ resources?.['mc.adyenOnboarding.table.incomingPaymentStatus'] }}</th>
                        <td>
                            <ng-container
                                [ngTemplateOutlet]="paymentStatusExpansionPanel"
                                [ngTemplateOutletContext]="{ $implicit: status, response, type: 'incoming' }"
                            ></ng-container>
                        </td>
                    </tr>
                }
                @if (compareToBalanceCapabilities(response); as status) {
                    <tr>
                        <th scope="row">{{ resources?.['mc.adyenOnboarding.table.outgoingPaymentStatus'] }}</th>
                        <td>
                            <ng-container
                                [ngTemplateOutlet]="paymentStatusExpansionPanel"
                                [ngTemplateOutletContext]="{ $implicit: status, response, type: 'outgoing' }"
                            ></ng-container>
                        </td>
                    </tr>
                }
            </tbody>
        </table>

        <div [class.invisible]="loading || response?.adyenStatus !== adyenOnboardingStatus.READY_FOR_HOP">
            <ng-template #belowTableInfoComponentPlaceholder phxDynamicComponent></ng-template>
        </div>
    </ng-container>
</div>

<ng-template #isLoading>
    <div class="text-center">
        <div class="spinner-border text-danger" role="status"></div>
    </div>
</ng-template>

<ng-template #merchantNotReady>
    <div class="text-center pt-3">
        <ngb-alert type="primary" [dismissible]="false">{{ resources?.['mc.adyenOnboarding.info.message'] }}</ngb-alert>
    </div>
</ng-template>

<ng-template #paymentStatusExpansionPanel let-status let-response="response" let-type="type">
    <phx-expansion-panel>
        <div class="header-content">
            <span
                class="status fw-bold"
                [class]="adyenOnboardingStatusToCssClassMap.get(status)"
                [class.is-linked]="isPaymentStatusActionRequired(status)"
                (click)="navigateToAdyenOnboardingPageIfActionRequired($event, status)"
                (keydown.enter)="navigateToAdyenOnboardingPageIfActionRequired($event, status)"
                tabindex="0"
                >{{ getPaymentStatusDisplayString(status) }}</span
            >
            @if (isPaymentStatusActionRequired(status)) {
                <span> {{ resources?.['mc.adyenOnboarding.table.paymentStatus.actionRequired.headerInfo'] }}</span>
            }
        </div>
        @if (status !== capabilityDisplayStatus.OK) {
            <div class="body-content card bg-light my-2">
                <div class="card-body">
                    @if (status !== capabilityDisplayStatus.DEACTIVATED) {
                        <span>
                            {{ getPaymentStatusInfoMessage(status) }}
                        </span>
                    }
                    @if (status === capabilityDisplayStatus.DEACTIVATED && type) {
                        <span>
                            {{ getDeactivatedPaymentTypeInfo(type) }}
                        </span>
                    }
                    @if (status === capabilityDisplayStatus.ACTION_REQUIRED) {
                        <ul class="error-list">
                            @for (error of getSendErrors(response); track error) {
                                <li>
                                    {{ gePaymentStatusErrorString(error) }}
                                </li>
                            }
                        </ul>
                    }
                </div>
            </div>
        }
    </phx-expansion-panel>
</ng-template>
